import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Components
import TableCountDropdown from '../../../../../../components/TableCountDropdown';
import ResponsiveTable from '../../../../../../components/ResponsiveTable';
import ReportsHarvestInspectionsPeoplePagination from './components/ReportsHarvestInspectionsPeoplePagination';
import ReportsHarvestInspectionsPeopleTableHead from './components/ReportsHarvestInspectionsPeopleTableHead';
import ReportsHarvestInspectionsPeopleTableRow from './components/ReportsHarvestInspectionsPeopleTableRow';

// // Selectors
import { selectIds } from './selectors';

interface Props {
    ids?: number[];
}

export class ReportsHarvestInspectionsPeopleTable extends React.PureComponent<Props> {
    render() {
        const { ids } = this.props;
        return (
            <div>
                <ResponsiveTable style={{ marginTop: 0 }}>
                    <Table
                        // selectable
                        sortable
                        // fixed
                        striped
                        singleLine
                        unstackable
                        size="small"
                    >
                        <ReportsHarvestInspectionsPeopleTableHead />
                        <Table.Body>
                            {(!ids || !ids.length) && (
                                <Table.Row colSpan="4" textAlign="center">
                                    <Table.Cell
                                        colSpan="4"
                                        className="events-table-cell-padding"
                                    >
                                        There are no harvest quality people
                                        reports.
                                    </Table.Cell>
                                </Table.Row>
                            )}
                            {ids &&
                                ids.map(id => (
                                    <ReportsHarvestInspectionsPeopleTableRow
                                        personId={id}
                                        key={id}
                                    />
                                ))}
                        </Table.Body>
                    </Table>
                </ResponsiveTable>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginLeft: 'auto' }}>
                        <TableCountDropdown
                            defaultCount={5}
                            namespace="people"
                        />
                        <ReportsHarvestInspectionsPeoplePagination />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    ids: selectIds
});

export default connect(mapStateToProps)(ReportsHarvestInspectionsPeopleTable);
